import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Admin {
  id: string;
  email: string;
  displayName: string | null;
  role: string;
}

interface AdminAuthState {
  admin: Admin | null;
  accessToken: string | null;
  isAuthenticated: boolean;

  setAdminAuth: (admin: Admin, accessToken: string) => void;
  adminLogout: () => void;
}

/**
 * Admin auth is kept in a separate store from the player auth so they
 * never collide. Persisted to sessionStorage (NOT localStorage) so the
 * admin token does not survive a browser restart \u2014 reduces risk if the
 * device is borrowed/stolen.
 */
export const useAdminStore = create<AdminAuthState>()(
  persist(
    (set) => ({
      admin: null,
      accessToken: null,
      isAuthenticated: false,
      setAdminAuth: (admin, accessToken) =>
        set({ admin, accessToken, isAuthenticated: true }),
      adminLogout: () =>
        set({ admin: null, accessToken: null, isAuthenticated: false }),
    }),
    {
      name: 't3-admin-auth',
      storage: {
        getItem: (name) => {
          const value = sessionStorage.getItem(name);
          return value ? JSON.parse(value) : null;
        },
        setItem: (name, value) => sessionStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => sessionStorage.removeItem(name),
      },
    }
  )
);
